// docs/product-image-and-error-handling-plan.md Step 2 — the single place
// that extracts a user-facing message from a failed API response. Reads
// only the backend's dedicated `message`/`error` field (never dumps the
// raw response body/JSON into the UI) — safe by construction now that
// app_be's sendServerError (utils/errorResponse.js) guarantees those
// fields are never raw Sequelize/DB internals.
export async function parseApiError(response: Response, fallback: string): Promise<string> {
  try {
    const data = await response.json();
    return data.message || data.error || fallback;
  } catch {
    return fallback;
  }
}
